import {
  ArrowUpRight,
  Circle,
  ClipboardList,
  Hand,
  Lasso,
  Pen,
  Slash,
  Square,
  StickyNote,
  Type,
  UserRound,
} from "lucide-react";
import type { ToolDef } from "../canvas-kit/ui/tool-palette/tool-palette.jsx";

/**
 * Tool ids available in the Whiteboard editor. Each id maps to either
 * a select-mode (`select`, `lasso`), a canvas-kit drawing primitive,
 * or a whiteboard-specific element (`sticky`).
 *
 * Labels + icons mirror the Tactics palette where applicable so users
 * find the same vocabulary across both surfaces.
 */
export type WhiteboardToolMode =
  | "select"
  | "lasso"
  | "pen"
  | "line"
  | "arrow"
  | "rect"
  | "circle"
  | "text"
  | "sticky"
  | "player"
  | "card";

export const WHITEBOARD_TOOLS: readonly ToolDef<WhiteboardToolMode>[] = [
  { id: "select", label: "Wählen", Icon: Hand, group: "select" },
  { id: "lasso", label: "Lasso", Icon: Lasso, group: "select" },
  { id: "pen", label: "Stift", Icon: Pen, group: "draw" },
  { id: "line", label: "Linie", Icon: Slash, group: "draw" },
  { id: "arrow", label: "Pfeil", Icon: ArrowUpRight, group: "draw" },
  { id: "rect", label: "Recht.", Icon: Square, group: "draw" },
  { id: "circle", label: "Kreis", Icon: Circle, group: "draw" },
  { id: "text", label: "Text", Icon: Type, group: "draw" },
  { id: "sticky", label: "Sticky", Icon: StickyNote, group: "place" },
  { id: "player", label: "Spieler", Icon: UserRound, group: "place" },
  { id: "card", label: "Karte", Icon: ClipboardList, group: "place" },
] as const;

/** Tools whose style controls (color / width / dashed) are shown in the palette. */
export const WHITEBOARD_PALETTE_STYLE_TOOLS: ReadonlySet<WhiteboardToolMode> = new Set([
  "pen",
  "line",
  "arrow",
  "rect",
  "circle",
  "text",
]);

/** Tools that actively produce drawing primitives via `useDrawing`. */
export const WHITEBOARD_DRAW_TOOL_SET: ReadonlySet<WhiteboardToolMode> = new Set([
  "pen",
  "line",
  "arrow",
  "rect",
  "circle",
  "lasso",
]);
